import { GetPredictiveDriveTimeReportInput, PredictiveDriveTimeReport } from '@/models/gen/graphql';

import { GetPredictiveDriveTimeReportDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';
import { handleError } from '@/utils/custom';

type GetPredictiveDriveTimeReportGraphApiResponse = GraphApiResponse<typeof GetPredictiveDriveTimeReportDocument>;

const title = 'Get Predictive Drive Time Report';

const getPredictiveDriveTimeReportResponseSelector = (res: GetPredictiveDriveTimeReportGraphApiResponse): PredictiveDriveTimeReport =>
  res.errors ? undefined : (res?.getPredictiveDriveTimeReport?.output as PredictiveDriveTimeReport);

const [_runGetPredictiveDriveTimeReport, runRefetchGetPredictiveDriveTimeReport] = graphApi(GetPredictiveDriveTimeReportDocument, {
  onError: (res: GetPredictiveDriveTimeReportGraphApiResponse): void => handleError(res, { notification: { title } }),
});

export const getPredictiveDriveTimeReport = async (input: GetPredictiveDriveTimeReportInput): Promise<PredictiveDriveTimeReport> => {
  const res = await runRefetchGetPredictiveDriveTimeReport({ input });
  return getPredictiveDriveTimeReportResponseSelector(res);
};

export const useGetPredictiveDriveTimeReport = createGraphApiHook(getPredictiveDriveTimeReport);
